import React, { useContext } from "react";
import styles from "../../Components/ShippingAddressScreen/ShippingAddressScreen.module.scss";
import { Col, Radio, Row } from "antd";
import hermes_logo from "../../Components/ShippingAddressScreen/images/hermes_logo.svg";
import dpd_logo from "../../Components/ShippingAddressScreen/images/dpd_logo.svg";
import ups_logo from "../../Components/ShippingAddressScreen/images/ups_logo.svg";
import { CartContext } from "../../Contexts/CartContext";
import { FeatureFlag } from "../../Components/FeatureFlag/FeatureFlag";
import { Divider } from "antd";

const DeliveryMethods = () => {
  const cartContext = useContext(CartContext);

  const { deliveryMethod, setDeliveryMethod } = useContext(CartContext);

  return (
    <div>
      <div className={styles.delivery_methods + " " + styles.custom_dm_wrapper}>
        <div className={styles.title}>
          <p className={"fw-bold"}>Shipping & Payment Information</p>
        </div>

        <Row gutter={[15, 15]}>
          <Col xs={24} lg={6}>
            <div
              className={"d-flex align-items-center gap-2 custom_radio_box"}
              onClick={() => {
                cartContext.setDeliveryType("Standard Free Delivery");
                cartContext.setActionCount(Math.random());
              }}
            >
              <Radio
                checked={cartContext.deliveryType === "Standard Free Delivery"}
              />
              <div>
                <b className={"fs-3"}>Standard Free Delivery</b>
                <p>
                  (From 49€, Max. 30kg box) Delivery within 3 - 4 days
                  (Excluding holidays).
                </p>
              </div>
            </div>
          </Col>
          {window.innerWidth < 576 && <Divider className="divider-90" />}
          <Col xs={24} lg={6}>
            <div
              className={"d-flex align-items-center gap-2 custom_radio_box"}
              onClick={() => {
                cartContext.setDeliveryType("Standard Delivery");
                cartContext.setActionCount(Math.random());
              }}
            >
              <Radio
                checked={cartContext.deliveryType === "Standard Delivery"}
              />
              <div>
                <p>
                  <b className={"fs-3"} style={{ paddingRight: ".5rem" }}>
                    Standard Delivery (3.99€)
                  </b>
                  (Between 25€ to 49€, Max. 30kg box) Delivery within 3 - 4 days
                  (Excluding holidays).
                </p>
              </div>
            </div>
          </Col>

          {/* <Col xs={24} lg={6}>
            <div
              className={"d-flex align-items-center gap-2 custom_radio_box"}
              onClick={() => {
                cartContext.setDeliveryType("Express Delivery");
                cartContext.setActionCount(Math.random());
              }}
            >
              <Radio
                checked={cartContext.deliveryType === "Express Delivery"}
              />
              <div>
                <b className={"fs-3"}>Express Delivery (5.50€)</b>
                <p>
                  (Min. basket value 25€) Max. 30kg box Delivery within 1 - 2
                  days (Excluding holidays).
                </p>
              </div>
            </div>
          </Col> */}
          {/* 
          {window.innerWidth < 576 && <Divider className="divider-90" />}

          <Col xs={24} lg={6}>
            <div
              className={"d-flex align-items-center gap-2 custom_radio_box"}
              onClick={() => {
                cartContext.setDeliveryType("Munich Special Delivery");
                cartContext.setActionCount(Math.random());
              }}
            >
              <Radio
                checked={cartContext.deliveryType === "Munich Special Delivery"}
              />
              <div>
                <b className={"fs-3"}>Munich Special Delivery (3.50€)</b>
                <p>
                  (Between 25€ to 49€) Munich Special Delivery Delivered within
                  0 - 1 day (Excluding holidays).
                </p>
                <b style={{ fontStyle: "italic", fontSize: 12 }}>
                  Same day delivery for orders received until 02:00PM
                </b>
              </div>
            </div>
          </Col> */}
        </Row>
      </div>


      {/* <div className={styles.delivery_methods}>
        <div className={styles.title}>
          <p>Select your Delivery Partner</p>
        </div>

        <Row gutter={[15, 15]}>
          <FeatureFlag name="dpdDeliveryMethodSelection">
            <Col lg={12} xs={24}>
              <div
                className={"custom_radio_box d-flex align-items-center"}
                onClick={() => setDeliveryMethod("dpd")}
              >
                <div>
                  <Radio checked={deliveryMethod === "dpd"} />
                  <b>DPD</b>
                </div>
                <img style={{ marginLeft: "auto" }} src={dpd_logo} alt="" />
              </div>
            </Col>
          </FeatureFlag>
          <Col lg={12} xs={24}>
            <div
              className={"custom_radio_box d-flex align-items-center"}
              onClick={() => setDeliveryMethod("desi_fresh")}
            >
              <div className={"d-flex align-items-center"}>
                <Radio
                  checked={deliveryMethod === "desi_fresh"}
                  style={{ marginTop: "0" }}
                />
                <div>
                  <b>Desi Fresh</b>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "var(--color-grey)",
                      marginBottom: 0,
                    }}
                  >
                    Currently available for Munich region
                  </p>
                </div>
              </div>
              <img
                style={{ marginLeft: "auto" }}
                src={"/icon/checkout/df-delivery.svg"}
                alt=""
              />
            </div>
          </Col>
        </Row>
      </div> */}
    </div>
  );
};

export default DeliveryMethods;
